import { render, staticRenderFns } from "./SetPreferencePage.vue?vue&type=template&id=6a419b6b&scoped=true&"
import script from "./SetPreferencePage.vue?vue&type=script&lang=js&"
export * from "./SetPreferencePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a419b6b",
  null
  
)

export default component.exports